/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, Output, EventEmitter, ElementRef, Renderer, HostBinding, ViewEncapsulation } from '@angular/core';
import { OnInit, Inject, Optional, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, COMPOSITION_BUFFER_MODE } from '@angular/forms';

import { InputBox } from './input';

import { Subject } from 'rxjs/Subject';
import'rxjs/add/operator/debounceTime';
import'rxjs/add/operator/distinctUntilChanged';

const /** @type {?} */ INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Search),
    multi: true
};
export class Search extends InputBox implements OnInit {
/**
 * 自动查询延迟时间（ms），默认300毫秒
 */
triggerDelay = 300;
/**
 * \@output {event} 回车执行查询
 */
search = new EventEmitter<any>();
private searchTerms = new Subject<string>();
/**
 * @param {?} renderer2
 * @param {?} elementRef2
 * @param {?} compositionMode2
 */
constructor(
private renderer2: Renderer,
private elementRef2: ElementRef,
private compositionMode2: boolean) {
        super(renderer2, elementRef2, compositionMode2);

    }
/**
 * @return {?}
 */
ngOnInit(): void {
        if (this.triggerDelay > 0) {
            this.searchTerms
                .debounceTime(this.triggerDelay)  // wait for 300ms pause in events
                .distinctUntilChanged()   // ignore if next search term is same as previous
                .subscribe((term: string) => {
                    this.search.emit(term);
                });
        }
    }
/**
 * @return {?}
 */
get inputClass(): string {
        return `${super.getInputClass()} ${this.prefixCls}-search has-suffix`;
    }
/**
 * @return {?}
 */
get searchIconClass(): string {
        return `${this.prefixCls}-search-icon`;
    }
/**
 * 样式
 * @return {?}
 */
get classes(): string {
        return this.affixWrapperClass;
    }
/**
 * @param {?} term
 * @return {?}
 */
push(term: string): void {
        this.searchTerms.next(term);
    }
/**
 * @return {?}
 */
onSearch(): void {
        this.search.emit(this.innerValue);
        this.doFocus();
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-search',
    templateUrl: './search.html',
    styleUrls: ['./style/search-input.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, decorators: [{ type: Inject, args: [Renderer, ] }, ]},
{type: ElementRef, decorators: [{ type: Inject, args: [ElementRef, ] }, ]},
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [COMPOSITION_BUFFER_MODE, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'triggerDelay': [{ type: Input },],
'search': [{ type: Output },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Search_tsickle_Closure_declarations() {
/** @type {?} */
Search.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Search.ctorParameters;
/** @type {?} */
Search.propDecorators;
/**
 * 自动查询延迟时间（ms），默认300毫秒
 * @type {?}
 */
Search.prototype.triggerDelay;
/**
 * \@output {event} 回车执行查询
 * @type {?}
 */
Search.prototype.search;
/** @type {?} */
Search.prototype.searchTerms;
/** @type {?} */
Search.prototype.renderer2;
/** @type {?} */
Search.prototype.elementRef2;
/** @type {?} */
Search.prototype.compositionMode2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
